import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import type { Action } from 'redux';
import { Button } from '@mui/material';

import {
  fetchEditorialTaxonomyPosts,
  startInfiniteScrolling,
} from 'actions/editorialTaxonomyPosts';
import type { AppState } from 'stores';

import styles from './LoadMorePosts.module.scss';

interface LoadMorePostsProps {
  doStartInfiniteScrolling: () => Action;
  doFetchTaxonomyPosts: (taxonomy: string, term: string, subCategory: string) => void;
  infiniteScrollingEnabled: boolean;
  term: string;
  taxonomy: string;
  subCategory: string;
}

const LoadMorePosts = ({
  infiniteScrollingEnabled,
  doFetchTaxonomyPosts,
  doStartInfiniteScrolling,
  taxonomy,
  term,
  subCategory,
}: LoadMorePostsProps) => {
  const handleWaypointEnter = useCallback(() => {
    doFetchTaxonomyPosts(taxonomy, term, subCategory);
  }, [doFetchTaxonomyPosts, subCategory, taxonomy, term]);
  return (
    <div className={styles.loadMorePosts} data-testid="load-more">
      {infiniteScrollingEnabled ? (
        <Waypoint onEnter={handleWaypointEnter} />
      ) : (
        <Button className={styles.button} variant="secondary" onClick={doStartInfiniteScrolling}>
          Load More
        </Button>
      )}
    </div>
  );
};

// TODO Need to adjust the store to include new stuff
export default connect(
  (state: AppState) => ({
    infiniteScrollingEnabled: state.editorialTaxonomyPosts.infiniteScroll,
  }),
  (dispatch: any) => ({
    doFetchTaxonomyPosts: (taxonomy: string, term: string, subCategory: string) =>
      dispatch(fetchEditorialTaxonomyPosts(taxonomy, term, subCategory, null, false)),
    doStartInfiniteScrolling: () => dispatch(startInfiniteScrolling()),
  }),
)(LoadMorePosts);
